type Length<T extends unknown[]> = T extends { length: infer L } ? (L extends number ? L : never) : never;

type BuildTuple<L extends number, T extends unknown[] = []> = T extends { length: L }
    ? T
    : BuildTuple<L, [...T, unknown]>;

type Add<A extends number, B extends number> = Length<[...BuildTuple<A>, ...BuildTuple<B>]>;

export type IntRange<TMin extends number, TMax extends number> = TMin extends TMax
    ? TMin
    : TMin | IntRange<Add<TMin, 1>, TMax>;

export function clamp(value: number, min: number, max: number): number {
    if (value > max) {
        return max;
    }
    if (value < min) {
        return min;
    }
    return value;
}

export function clampUInt<TLeft extends number, TRight extends number>(
    value: number,
    min: TLeft,
    max: TRight
): IntRange<TLeft, TRight> {
    const result: number = clamp(value, min, max);
    // @ts-ignore
    return result;
}

export function sign(value: number): -1 | 0 | 1 {
    if (value < 0) {
        return -1;
    }
    if (value > 0) {
        return 1;
    }
    return 0;
}
